// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"messageOverlay_wrapper__1DVNW","fade-in":"messageOverlay_fade-in__1Ebd9","card":"messageOverlay_card__1_Iyf","slide-in":"messageOverlay_slide-in__304t6"};